const ACCOUNT_CHANGE_CLICK = ' AccountChangeClick';
const ACTION_ACCOUNT_CONNECT_CLICK = 'AccountConnectClick';
const ACTION_CAPTCHA_ERROR = 'CaptchaFailed';
const ACTION_CONTACT_PHONE_CLICK = 'ContactPhoneClick';
const ACTION_CREATE_ACCOUNT_BEGIN = 'CreateAccountBegin';
const ACTION_CREATE_ACCOUNT_DIALOG_CLOSED = 'CreateAccountDialogClosed';
const ACTION_CREATE_ACCOUNT_FAILED = 'CreateAccountFailed';
const ACTION_CREATE_ACCOUNT_SUCCESS = 'CreateAccountSuccess';
const ACTION_STEP_LOADED = 'StepLoaded';
const ACTION_SUBMIT_CREATE_USER_CLICK = 'SubmitCreateAccountClick';
const ACTION_TAB_CLICKED = 'TabClicked';
const CONFIRM_CLICK = 'ClickConfirm';
const CREATE_ACCOUNT_CLICK = 'CreateAccountClick';
const CREATE_ACCOUNT_WITH_SOCIAL_CLICK = 'CreateAccountWithSocialClick';
const FORM_ERROR_TC_NOT_ACCEPTED = 'FormErrorTcNotAccepted';
const FORM_NEXT_STEP_CLICK = 'FormNextStepClick';
const LABEL_CREATE_ACCOUNT_MODAL = 'CreateAccountDialog';
const LEARNING_CENTER_CLICK = 'LearningCenterClick';
const SELLER_REVIEW_CLICK = 'SellerReviewClick';
const SELLER_REVIEW_EXTERNAL_LINK_CLICK = 'ExternalReviewsLinkClicked';
const SELLER_REVIEW_TAB_CLICK = 'SellerReviewTabClick';
const SELLER_REVIEW_LOCATION_CLICK = 'SellerReviewDropDownClick';
const SELLER_REVIEW_LOCATION_CHANGE = 'SellerReviewLocationChanged';

const stepLabels = {
  STEP1: 'tab-1',
  STEP2: 'tab-2',
  STEP3: 'tab-3',
  STEP4: 'tab-4',
};

export {
  ACCOUNT_CHANGE_CLICK,
  ACTION_ACCOUNT_CONNECT_CLICK,
  ACTION_CAPTCHA_ERROR,
  ACTION_CONTACT_PHONE_CLICK,
  ACTION_CREATE_ACCOUNT_BEGIN,
  ACTION_CREATE_ACCOUNT_DIALOG_CLOSED,
  ACTION_CREATE_ACCOUNT_FAILED,
  ACTION_CREATE_ACCOUNT_SUCCESS,
  ACTION_STEP_LOADED,
  ACTION_SUBMIT_CREATE_USER_CLICK,
  ACTION_TAB_CLICKED,
  CONFIRM_CLICK,
  CREATE_ACCOUNT_CLICK,
  CREATE_ACCOUNT_WITH_SOCIAL_CLICK,
  FORM_ERROR_TC_NOT_ACCEPTED,
  FORM_NEXT_STEP_CLICK,
  LABEL_CREATE_ACCOUNT_MODAL,
  LEARNING_CENTER_CLICK,
  SELLER_REVIEW_CLICK,
  SELLER_REVIEW_EXTERNAL_LINK_CLICK,
  SELLER_REVIEW_TAB_CLICK,
  SELLER_REVIEW_LOCATION_CLICK,
  SELLER_REVIEW_LOCATION_CHANGE,
  stepLabels,
};
